
import { put, call, takeLatest} from "redux-saga/effects";
import * as Api from "../api";
import * as ActionConstants from "../actions/actionConstants";
import { ErrorCode } from '../../../containers/WorkkardDetail/constants';
import { SHOW_LOADER, HIDE_LOADER } from '../../../common/actionConstants';
import { pascalCaseKeys } from "../../../common/util";



export function* fetchOrganizationProfileData({ payload }) {
  try {
    yield put({ type: SHOW_LOADER });
    const { status, orgProfileData, orgSkillSets } = yield call(Api.fetchOrganizationProfileData, ActionConstants.FETCH_ORG_PROFILE_DATA_REQUEST);
    if (status == 200) {
      yield put({ type: ActionConstants.FETCH_ORG_PROFILE_DATA_SUCCESS, payload: { orgProfileData: Object.assign({},orgProfileData.CurrentOrganizationView,{restrictDomains:orgProfileData.RestrictedDomains}), orgSkillSets:orgSkillSets, timezoneData: orgProfileData.TimezoneData, hostName: orgProfileData.HostName, OrganizationSkills:orgProfileData.OrganizationSkills, Countries: JSON.parse(orgProfileData.AllCountries), serviceLocData:{ServiceLocationNames:orgProfileData.OrganizationServiceLocationNames,ServiceLocations:orgProfileData.OrganizationServiceLocations}} });
    } else if (status == ErrorCode.RedirectToLogout) {
      yield* logout();
    }
  }
  catch (error) {
    console.log(error);
  }
  finally {
    yield put({ type: HIDE_LOADER });
  }
}


export function* updateOrgProfileTimzeone({ payload }) {
  try {
    // yield put({ type:  ActionConstants.SET_UPDATING_DATA, payload: {key: 'fax'} });
    const { status } = yield call(Api.updateOrgProfileName, ActionConstants.UPDATE_ORG_PROFILE_TIMEZONE, { universalTimeZoneId: payload.universalTimeZoneId });
    if (status == 200) {
      yield put({ type: ActionConstants.UPDATE_ORG_PROFILE_INFO_SUCCESS, payload: payload });
    }
  }
  catch (error) {
    console.log(error)
  }
  finally {
    yield put({ type: ActionConstants.SET_UPDATING_DATA, payload: { key: null } });
  }
}

export function* getOrgLocationByZip(action) {
  try {
    const { suggestion, code } = yield call(Api.getOrgLocationByZip, action.payload);
    const result = pascalCaseKeys(suggestion);
    if (code == 200) {
      yield put({
        type: ActionConstants.FETCH_ORG_PROPERTY_LOCATION_SUCCESS,
        payload: result
      })
    }
  }
  catch (error) {
    console.log(error);
  }
}


export function* updateOrganizationLogo({ payload }) {
  try {
    const callback = payload.callback;
    delete payload.callback;
    const { status, url } = yield call(Api.updateOrganizationLogo, ActionConstants.UPDATE_ORG_IMAGE_COORDINATES, payload);
    if (status == 200) {
      callback();
      yield put({
        type: ActionConstants.UPDATE_ORG_LOGO,
        payload:url
      })
    }
  }
  catch (error) {
    console.log(error)
  }
  finally {
  }
}

export function* addTagForOrg({ payload }) {
  try {
    const { status } = yield call(Api.addTagForOrg, ActionConstants.ADD_ORG_SKILLSET, payload);
    if (status == 200) {
     yield* fetchUpdatedOrgProfileData();
     
    }
  }
  catch (error) {
    console.log(error)
  }
  finally {
  }
}


export function* removeTagForOrg({ payload }) {
  try {
    const { status } = yield call(Api.removeTagForOrg, ActionConstants.REMOVE_ORG_SKILLSET, payload);
    if (status == 200) {
      yield* fetchUpdatedOrgProfileData();
    }
  }
  catch (error) {
    console.log(error)
  }
  finally {
  }
}

export function* fetchServiceLocData({ payload }) {
  try {
    const callback = payload.callback;
    delete payload.callback;
    const response= yield call(Api.fetchServiceLocData, payload);
    if (response) {
       let data = response.results;
      callback(data==null ? []  : data );
    }
  }
  catch (error) {
    console.log(error)
  }
  finally {
  }
}

export function* fetchZipDataApi({payload}) {
  try {
    const callback = payload.callback;
    delete payload.callback;
    const response= yield call(Api.fetchZipDataApi, payload);
    if (response) {
      let data = response.result;
      callback(data==null ? []  : data );
    }
  }catch(error) {
    console.log(error)
  }finally {}
}

export function* addOrRemoveServiceLocNames({ payload }) {
  try {
    const response = yield call(Api.addOrRemoveServiceLocNames, payload);
    if (response) {
      return
    }
  }
  catch (error) {
    console.log(error)
  }
  finally { }
}

export function* removeOrgLogo({ payload }) {
  try {
    const response = yield call(Api.removeOrgLogo, ActionConstants.REMOVE_ORG_LOGO);
    if (response.status==200) {
      yield put({
        type: ActionConstants.REMOVE_ORG_LOGO_SUCCESS,
        payload:response.photoUrl
      }) 
    }
  }
  catch (error) {
    console.log(error)
  }
  finally {
  }
}

export function* fetchUpdatedOrgProfileData()
{
  try{
    const response = yield call(Api.fetchOrganizationProfileData, ActionConstants.FETCH_ORG_PROFILE_DATA_REQUEST); 
    if (response.status == 200) {
     yield put({ type: ActionConstants.SET_UPDATING_ORG_DATA, payload: response.orgProfileData.CurrentOrganizationView.IsProfileComplete });
    }
  }
  catch(error)
  {
console.log(error);
  }
}

export function* fetchAllSkilset(){
  try {
    const response = yield call(Api.fetchAllSkilset);
    if (response) {
       let orgSkillSets = response.skillset;
      yield put({ 
        type: ActionConstants.FETCH_ORGSKILLSETS_SUCCESS, 
        payload: orgSkillSets
      });
    }
  }catch(error) {
    console.log(error)
  }
} 


export default [
  takeLatest(ActionConstants.FETCH_ORG_PROFILE_DATA_REQUEST, fetchOrganizationProfileData),
  takeLatest(ActionConstants.UPDATE_ORG_PROFILE_TIMEZONE, updateOrgProfileTimzeone),
  takeLatest(ActionConstants.FETCH_ORG_PROPERTY_LOCATION, getOrgLocationByZip),
  takeLatest(ActionConstants.UPDATE_ORG_IMAGE_COORDINATES, updateOrganizationLogo),
  takeLatest(ActionConstants.ADD_ORG_SKILLSET, addTagForOrg),
  takeLatest(ActionConstants.REMOVE_ORG_SKILLSET, removeTagForOrg),
  takeLatest(ActionConstants.FETCH_LOCATION_NAMES,fetchServiceLocData),
  takeLatest(ActionConstants.FETCH_ZIP_DATA, fetchZipDataApi),
  takeLatest(ActionConstants.ADD_REMOVE_SERVICE_LOCATION_NAMES, addOrRemoveServiceLocNames),
  takeLatest(ActionConstants.REMOVE_ORG_LOGO, removeOrgLogo),
  takeLatest(ActionConstants.FETCH_ALL_SKILSET, fetchAllSkilset)
];
